import type { BudgetListItem } from '@fdh/shared';

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** Main Money Received periods whose date range covers any of the given receipt dates. */
export const matchMainBudgetsForReceiptDates = (
  budgets: BudgetListItem[],
  receiptDates: readonly string[],
): BudgetListItem[] => {
  const dates = [
    ...new Set(receiptDates.filter((date) => ISO_DATE_RE.test(date))),
  ];
  if (dates.length === 0) {
    return [];
  }

  const mains = budgets.filter((row) => row.budgetKind === 'main');
  const matched = mains.filter((budget) =>
    dates.some((date) => date >= budget.startDate && date <= budget.endDate),
  );

  return [...matched].sort((a, b) => {
    if (a.startDate !== b.startDate) {
      return b.startDate.localeCompare(a.startDate);
    }
    return (b.createdAt ?? '').localeCompare(a.createdAt ?? '');
  });
};

export const buildSettlementsHrefForBudgets = (
  budgets: readonly BudgetListItem[],
): string => {
  if (budgets.length === 1) {
    return `/settlements?mainBudgetId=${encodeURIComponent(budgets[0].id)}`;
  }
  return '/settlements';
};
